import { Component, ViewChild, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { customfunctions, DataParam } from '../common/customfunctions';
import { FileToUpload } from '../file-upload/file-to-upload.model';
import { MonitorModel } from './articlemonitor-model';
import { ApiMethod } from '../apimethods/api-method';
import { zip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ArticleinfoComponent } from '../articleinfo/articleinfo.component';
import { ArticlemonitorinfoComponent } from '../articlemonitorinfo/articlemonitorinfo.component';
declare var $;

@Component({
  selector: 'app-articlemonitor',
  templateUrl: './articlemonitor.component.html',
  styleUrls: ['./articlemonitor.component.css']
})
/** articlemonitor component*/
export class ArticleMonitorComponent {
  /** articlemonitor ctor */
  modelItem: MonitorModel = new MonitorModel();
  http: HttpClient;
  showModal: boolean;
  showInfoModal: boolean; showInfoMetadataModal: boolean;
  showAuthorModal: boolean;
  showFundingModal: boolean;
  title: string;
  infoTitle: string;
  articleNotes: string;
  dataTable: any;
  dtAuthor: any;
  dtFunding: any;
  dtOptions: any;
  dtFile: any;
  nAuthIndex: number;
  nFundIndex: number;
  articleNo: string;
  articleTitle: string;
  articleSubTitle: string;
  articleType: string;
  authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  isHold: boolean;
  holdType: string;
  license: string;
  public allocateUserId: boolean = false; showCorrepSelect: boolean = false;
  public allocatedId: string;
  public lVolumeList: any;
  public lSubjectList: any;
  public lArticleTypeList: any;
  public lJournalList: any;
  public lStatusList: any;
  public lAuthorList: any;
  public lFundingList: any;
  public lFileList: string[] = [];
  fileBase64: string = "";
  articleId: number;
  tableData = [];
  fileToUpload: File = null;
  fileCount: number = 0;
  filePath: any;
  files: string[] = [];
  firstReleaseArticleId: string;
  @ViewChild('dataTable') table;
  @ViewChild('dtAuthor') dtTable;
  @ViewChild('dtFunding') dtFundingTable;
  @ViewChild('chkHold') chkHoldRelease;
  monthNames = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];
  dataSet: any;
  dataSetFunding: any;
  journalList: any;
  issueList: any;
  volumeList: any;

  ngOnInit() {
    $("#lstJournals").select2({
      placeholder: "Select Journal", dropdownParent: "#divMainFilter"
    }); $("#lstJournals").val([]).trigger("change");

    $("#lstVolume").select2({
      placeholder: "Select Volume", dropdownParent: "#divMainFilter"
    });
    $("#lstVolume").val([]).trigger("change");

    $("#lstIssue").select2({
      placeholder: "Select Issue", dropdownParent: "#divMainFilter"
    });
    $("#ddlDataField,#ddlPressPak").select2({
      placeholder: "All", dropdownParent: "#divMainFilter"
    });

    $("#lstIssue").val([]).trigger("change");

    ApiMethod.getBaseUrl();

  }
  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <MonitorModel>data["MonitorPage"];
        localStorage.aEID = 0;
        $('#ddlStatus').select2({ placeholder: "Select", dropdownParent: ".divContainer" });
        $('#ddlField').select2({ placeholder: "Select", dropdownParent: ".divContainer" });
        $('#ddlMailTo').select2({ placeholder: "Select", dropdownParent: ".divContainer" });

        //this.getStatusList();
        this.getArticleList();
        this.getJournalsList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getArticleList(skipLoading = false, stateSave = false): void {
    if (!skipLoading) {
      $("#LoadingImage").show();
    }
    var fromDate = $('#Txt_FromDate').val();
    var toDate = $('#Txt_ToDate').val();

    if (fromDate == "" || toDate == "")
      fromDate = $('#Txt_FromDate').val();
    toDate = $('#Txt_ToDate').val();

    var selectedStatus = $("#ddlStatus option:selected").val();
    if (selectedStatus == "")
      selectedStatus = 'All';

    var selectedField = $("#ddlField option:selected").val();
    if (selectedField == "")
      selectedField = 'All';

    var articleData = {
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text(),
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      fromDate: fromDate.toString(),
      toDate: toDate.toString(),
      selectedStatus: selectedStatus,
      selectedField: selectedField,
      PressPak: $("#ddlPressPak").val()
    };
    ApiMethod.postMethod(this.modelItem.articleListApi, articleData).subscribe(
      result => {
        if (this.lStatusList == null)
          this.lStatusList = result.artStatusList;

        this.dataSet = JSON.stringify(result.aArticleList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'ArticleModule';
        dataItem.infoPopupID = 'ID';
        dataItem.StateSave = stateSave;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

  }
  getFiltered() {
    this.getArticleList();
  }

  resetFilter() {
    $('#ddlStatus').val("All").change();
    $('#ddlField').val("All").change();
    $("#ddlPressPak").val("All").change();
    this.getArticleList();
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');
  }
  setDateValues() {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $('#Txt_ToDate').val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 7));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $("#Txt_FromDate").val(prevToday);
  }
  getJournalsList() {
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  showInfoPopUp(): void {
    ArticlemonitorinfoComponent.ArticleInfo(localStorage.aEID);
    $('#btnPopupartMeta').trigger('click');
  }
  
  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;

        $("#lstIssue").val(-1).trigger("change");
        $("#lstVolume").val(-1).trigger("change");

      }, error => {
        $("#LoadingImage").hide();
      });
  }
}
